var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhotoGalleryOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#photo-gallery-outline_svg__clip0_3408_33668)"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M0 5a1 1 0 011-1h22a1 1 0 011 1v18a1 1 0 01-1 1H1a1 1 0 01-1-1V5zm2 1v16h20V6H2zM5 1a1 1 0 011-1h12a1 1 0 110 2H6a1 1 0 01-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M15.19 10.018a1 1 0 01.704.535l4 8A1 1 0 0119 20H6a1 1 0 01-.664-1.747l9-8a1 1 0 01.853-.235zM8.63 18h8.752l-2.693-5.386L8.63 18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 12a2 2 0 100-4 2 2 0 000 4z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "photo-gallery-outline_svg__clip0_3408_33668"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgPhotoGalleryOutline;